<template>
  <div class="container">
    <div class="footer">
      <div class=" w">
        <div class="left-box">
          <img :src="this.$store.state.marketInfo.logo" alt="" />
          <div>
            <p>咨询电话：{{ this.$store.state.marketInfo.tel }}</p>
            <p>（周一至周日 08:30——19:00）</p>
          </div>
        </div>
        <div class="conter-box">
          <img :src="this.$store.state.marketInfo.weChatQrcode" alt="" />
          <div>
            <p>扫码关注公众号</p>
            <p>享受更多优惠！</p>
          </div>
        </div>
        <div class="right-box">
          <div class="bo1">
            <span @click="toPage('home')">首页</span> | <span @click="toPage('buy-car', '')">我要买车</span> | <span @click="toPage('sell-car')">我要卖车</span> |
            <span @click="toPage('buy-car', '1')">认证车</span> |
            <span @click="toPage('buy-car', '2')">热门推荐</span>
          </div>
          <div class="bo2">
            Copyright 2022 {{ this.$store.state.marketInfo.copyright }}
          </div>
          <div class="bo2">
            版权所有.<a href="https://beian.miit.gov.cn" target="_blank">{{ this.$store.state.marketInfo.icp }}</a>
          </div>
          <div class="bo2">地址：{{ this.$store.state.marketInfo.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {
    toPage(name, value) {
      var url = '/' + name
      if (url == this.$route.path) {
        return false
      } else {
        this.$router.push({
          path: url,
          query: {
            certifyTag: value
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  background-color: #333;
  width: 100%;
  padding: 20px;
  .w {
    display: flex;
    height: 100px;
    color: #fff;
    .left-box {
      width: 32%;
      height: 100%;
      display: flex;
      img {
        width: 100px;
        height: 100px;
      }
      div {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 14px;
        & p:nth-of-type(1) {
          font-size: 20px;
          line-height: 2;
        }
      }
    }
    .conter-box {
      width: 32%;
      height: 100%;
      display: flex;
      img {
        width: 100px;
        height: 100px;
      }
      div {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
    }
    .right-box {
      width: 36%;
      height: 100%;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      line-height: 2;
      .box1 {
        display: flex;
      }
    }
  }
}
a,
a:hover {
  /*去掉a链接的默认样式*/
  text-decoration: none;
  color: #fff;
}
a:visited {
  text-decoration: none;
  color: #fff;
}
</style>
